import './plugins/vuetify'
import App from './App.vue'
window.vue2 = require('vue').default

window.vue2.config.productionTip = false

window.vue2.component('roi-calc', App).default
new window.vue2().$mount('#roi-calc')
